import React from "react";
import MuiButton from "@material-ui/core/Button";
import styled from "styled-components";

import buttonStyle from "./buttonStyle";

export default styled(({ active, ...props }) => <MuiButton {...props} />)`
  ${buttonStyle}
`;
